import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const listingIdeaBlockSchema = Joi.object({
  type: Joi.string().valid('listingIdeaBlock').required(),
  code: Joi.string().allow('', null).required(),
  quantity: Joi.string().required(),
  ideas: Joi.array().items(Joi.object().keys({
    baseData: Joi.object().unknown(true).required()
  }).unknown(true)).allow(null),
  inspirationTags: Joi.object().unknown(true).allow(null),
  ...blockAppearanceSchema
}).unknown(true);
export default listingIdeaBlockSchema;